module.exports = __webpack_public_path__ + "static/media/Clear_Icon.a04ee5b5.svg";